import React from "react";
import { Check, Loader2, MinusCircle, X } from "lucide-react";
import { TspModal } from "../../../../components/primitives";
import { STEP_STATUS } from "../../saveJourneyCityDetails";

const STATUS_TEXT = { pending: "Waiting", saving: "Saving…", done: "Saved", failed: "Failed", skipped: "Not saved" };

function StatusIcon({ status }) {
  if (status === STEP_STATUS.done) return <Check size={14} aria-hidden="true" />;
  if (status === STEP_STATUS.saving) return <Loader2 size={14} className="tsp-spin" aria-hidden="true" />;
  if (status === STEP_STATUS.failed) return <X size={14} aria-hidden="true" />;
  if (status === STEP_STATUS.skipped) return <MinusCircle size={14} aria-hidden="true" />;
  return <span className="tsp-aj-step-dot" aria-hidden="true" />;
}

// Shown once the journey has been created, while its city details are saved
// ("saving"), and — if anything was refused — until the person retries what is
// missing or opens the journey to finish there ("review"). The journey itself
// already exists at this point; nothing here can create it again.
export default function AddJourneySaveProgress({ save, onRetry, onOpenJourney }) {
  const saving = save.phase === "saving";
  const entries = Object.entries(save.results);
  const title = saving ? "Saving city details…" : "Some city details were not saved";

  return (
    <TspModal
      open
      size="lg"
      title={title}
      onClose={saving ? () => {} : onOpenJourney}
      footer={
        saving ? null : (
          <>
            <button type="button" className="tsp-btn tsp-btn-outline-primary" onClick={onOpenJourney}>
              Open Journey
            </button>
            <button type="button" className="tsp-btn tsp-btn-success" onClick={onRetry}>
              Retry Failed
            </button>
          </>
        )
      }
    >
      <p className="tsp-muted-text">
        Journey “{save.journey.journey_name}” has been created.{" "}
        {saving ? "Its city details are being saved — please keep this page open." : "What failed can be retried here, or added later from the journey's city tabs."}
      </p>
      <div className="tsp-aj-progress" aria-live="polite">
        {entries.map(([stopId, entry]) => (
          <section key={stopId} className="tsp-aj-progress-city">
            <h4>{entry.label}</h4>
            <ul>
              {entry.steps.map((step) => (
                <li key={step.key} className={`tsp-aj-step tsp-aj-step-${step.status}`}>
                  <StatusIcon status={step.status} />
                  <span className="tsp-aj-step-label">{step.label}</span>
                  <span className="tsp-aj-step-status">{STATUS_TEXT[step.status]}</span>
                  {step.message && <span className="tsp-aj-step-message">{step.message}</span>}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </TspModal>
  );
}
